<div class="allsubviews-container">
  <app-curing></app-curing>
  <app-graph [isSubView]="true"></app-graph>
</div>
